import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { OPEN_PROBLEMS } from "./openProblems";
import "./ProblemRequests.css";

function ProblemMotif({ id }) {
  return (
    <div className={`problem-request-motif problem-request-motif-${id}`} aria-hidden="true">
      {id === "extrahepatic-sirna-delivery" && <><span className="problem-rna">RNA</span><i className="problem-delivery-path" /><i className="problem-target-cell"><b /></i></>}
      {id === "multimodal-data-integration" && <div className="problem-molecular-layers">{["DNA", "RNA", "Protein", "Chromatin"].map((layer) => <span key={layer}><i />{layer}</span>)}</div>}
      {id === "fusion-proteins" && <div className="problem-fusion"><span>A</span><i /><span>B</span></div>}
      {id === "cell-state-prediction" && <div className="problem-cell-states"><i><b /><b /><b /></i><span>→</span><i><b /><b /><b /></i></div>}
      {id === "early-safety-signals" && <div className="problem-safety"><i /><i /><i /><span>?</span></div>}
    </div>
  );
}

export default function ProblemRequests({ asPage = false, contactPath = "/contact" }) {
  const Heading = asPage ? "h1" : "h2";
  return (
    <section className="problem-requests" id="open-problems" aria-labelledby="problem-requests-title">
      <div className="home-editorial-shell">
        <div className="problem-requests-intro">
          <div>
            {!asPage && <p className="home-editorial-kicker">An open invitation</p>}
            <Heading id="problem-requests-title">Request for <span>problems.</span></Heading>
          </div>
          <p className="problem-requests-lead">
            We’re looking for teams working on these questions.
          </p>
        </div>

        <div className="problem-requests-grid">
          {OPEN_PROBLEMS.map((problem, index) => (
            <article className="problem-request" key={problem.id} aria-labelledby={`problem-${problem.id}`}>
              <span className="problem-request-number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
              <ProblemMotif id={problem.id} />
              <div className="problem-request-copy"><h3 id={`problem-${problem.id}`}>{problem.title}</h3><p>{problem.description}</p></div>
              <Link
                to={`${contactPath}?problem=${problem.id}&source=request-for-problems`}
                className="problem-request-link"
                aria-label={`Let’s tackle it: ${problem.title}`}
                data-problem-id={problem.id}
                data-cta="discuss-problem"
              >
                Let’s tackle it <ArrowUpRight size={18} aria-hidden="true" />
              </Link>
            </article>
          ))}
        </div>

        <div className="problem-requests-other">
          <Link className="problem-request-link" to={`${contactPath}?source=request-for-problems`}>
            Bring us a different problem <ArrowUpRight size={18} aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}
